import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

export default class {
  constructor () {
    this.state = {
      branches: [],
      products: [],
      locations: [],
      shipmentStatuses: [],
      suppliers: [],
      currencies: [],
      purchaseOrderStatuses: [],
      purchaseOrderDetailStatuses: [],
      purchaseOrderBalanceStatuses: [],
      statusesTransfers: [],
      statusesReceptions: [],
      statusesReceptionProducts: []
    }

    this.mutations = {
      SET_BRANCHES (state, payload) {
        state.branches = payload
      },
      SET_PRODUCTS (state, payload) {
        state.products = payload
      },
      SET_LOCATIONS (state, payload) {
        state.locations = payload
      },
      SET_SHIPMENT_STATUSES (state, payload) {
        state.shipmentStatuses = payload
      },
      SET_SUPPLIERS (state, payload) {
        state.suppliers = payload
      },
      SET_CURRENCIES (state, payload) {
        state.currencies = payload
      },
      SET_PURCHASE_ORDER_STATUSES (state, payload) {
        state.purchaseOrderStatuses = payload
      },
      SET_PURCHASE_ORDER_DETAILS_STATUSES (state, payload) {
        state.purchaseOrderDetailStatuses = payload
      },
      SET_PURCHASE_ORDER_BALANCE_STATUSES (state, payload) {
        state.purchaseOrderBalanceStatuses = payload
      },
      SET_STATUSES_TRANSFERS (state, payload) {
        state.statusesTransfers = payload.data
      },
      SET_STATUSES_RECEPTIONS (state, payload) {
        state.statusesReceptions = payload.data
      },
      SET_STATUSES_RECEPTION_PRODUCTS (state, payload) {
        state.statusesReceptionProducts = payload.data
      }
    }

    this.actions = {
      async getBranches ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`branches${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_BRANCHES', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getProducts ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`products${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_PRODUCTS', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getLocations ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`locations${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_LOCATIONS', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getShipmentStatuses ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`shipment-status${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_SHIPMENT_STATUSES', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getSuppliers ({ commit }, payload) {
        try {
          const response = await axios.get(`suppliers/all`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_SUPPLIERS', response.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getCurrencies ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`currencies${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_CURRENCIES', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getPurchaseOrderStatuses ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`purchase-order-statuses${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_PURCHASE_ORDER_STATUSES', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getPurchaseOrderDetailStatuses ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`purchase-order-details-statuses${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_PURCHASE_ORDER_DETAILS_STATUSES', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getPurchaseOrderBalancesStatuses ({ commit }, payload) {
        const filters = payload ? payload.filter : ''
        try {
          const response = await axios.get(`purchase-order-balance-statuses${filters}`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_PURCHASE_ORDER_BALANCE_STATUSES', response.data.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getStatusesTransfers ({ commit }) {
        try {
          const response = await axios.get(`statuses-transfer/all`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_STATUSES_TRANSFERS', response.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getStatusesReceptions ({ commit }) {
        try {
          const response = await axios.get(`statuses-reception/all`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_STATUSES_RECEPTIONS', response.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      },
      async getStatusesReceptionProducts ({ commit }) {
        try {
          const response = await axios.get(`statuses-reception-product/all`)
          const checkErrors = checkResponse(response)
          if (checkErrors) {
            commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
          } else {
            commit('SET_STATUSES_RECEPTION_PRODUCTS', response.data)
          }
        } catch (e) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
        }
      }
    }

    this.getters = {
      branches: state => state.branches,
      products: state => state.products,
      locations: state => state.locations,
      shipmentStatuses: state => state.shipmentStatuses,
      suppliers: state => state.suppliers,
      currencies: state => state.currencies,
      purchaseOrderStatuses: state => state.purchaseOrderStatuses,
      purchaseOrderDetailStatuses: state => state.purchaseOrderDetailStatuses,
      purchaseOrderBalanceStatuses: state => state.purchaseOrderBalanceStatuses,
      statusesTransfers: state => state.statusesTransfers,
      statusesReceptions: state => state.statusesReceptions,
      statusesReceptionProducts: state => state.statusesReceptionProducts
    }
  }
}
